export * from './firebase.app.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/~/angularfire2/app/index.js
// module id = ../../../../angularfire2/app/index.js
// module chunks = 4